module.exports = __webpack_public_path__ + "img/1-1.90836cd8.svg";